import { useDispatch } from "react-redux";
import { FormDomain } from "../../../../_components/Forms/FormDomain";
import { ContractorWastesWasteKindForm } from "./ContractorWastesWasteKindForm";
import * as Yup from "yup";
import { contractorsActions } from "../../../../_store/contractors.slice";
import { ratePlansActions } from "../../../../_store/ratePlan.slice";

export function ContractorWasteKindForm({ contractorId, addressId, defaultValues, setShowOffCanvas }) {
  const dispatch = useDispatch();
  const formControls = <div className="d-flex flex-column gap-2">
    <ContractorWastesWasteKindForm/>
  </div>;

  const wasteKindValidationSchema = Yup.object().shape({
    name: Yup.string().required("Nazwa gatunku jest wymagana").max(30, "Nazwa gatunku może mieć maksymalnie 30 znaków"),
  });

  const wasteValidationSchema = Yup.object().shape({
    waste: Yup.object().required("Towar jest wymagany").typeError("Towar jest wymagany"),
    kinds: Yup.array().of(wasteKindValidationSchema)
  });

  const validationSchema = Yup.object().shape({
    wastes: Yup.array().of(wasteValidationSchema)
  });

  const onSubmit = async(data) => {
    const usedWastes = data.wastes?.map(x => {
      const wasteKinds = x.wasteKinds.map((k) => ({ wasteKindId: k.wasteKindId, name: k.name }));
      return ({ id: x.waste?.wasteId, wasteKinds: wasteKinds });
    });

    const payload = {
      contractorId: contractorId,
      addressId: addressId,
      usedWastes: usedWastes
    }

    const response = await dispatch(contractorsActions.updateUsedWastes({ payload }));
    if (!response?.error) {
      const queryPayload = { contractorId, addressId }
      await dispatch(contractorsActions.getAddressUsedWastes({ payload: queryPayload }));
      await dispatch(ratePlansActions.getRatePlans({ id: contractorId }));
      setShowOffCanvas(false);
    }

    return response;
  };

  return (
    <>
      <FormDomain
        formControls={formControls}
        validationSchema={validationSchema}
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        // buttonText={buttonText}
        successMessage="Zaktualizowano gatunki"
        title="Gatunki towarów"
        btnSize="small"
        addSubmitFooter={false}
      />
    </>
  );
}